import { Children, useState } from 'react';
import PropTypes from 'prop-types';

import useInterval from 'utils/useInterval';

const SlideShow = ({ children, restTime }) => {
  const childrenCount = Children.count(children);
  const [currentChild, setCurrentChild] = useState(0);

  useInterval(() => {
    setCurrentChild((currentChild + 1) % childrenCount);
  }, restTime);

  return children[currentChild];
};

SlideShow.propTypes = {
  children: PropTypes.node.isRequired,
  restTime: PropTypes.number,
};

SlideShow.defaultProps = {
  restTime: 800,
};

export default SlideShow;
